var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._ssrNode(
      (this.resizeEdges.includes("t")
        ? '<div class="vue-modal-top"></div>'
        : "<!---->") +
        " " +
        (this.resizeEdges.includes("b")
          ? '<div class="vue-modal-bottom"></div>'
          : "<!---->") +
        " " +
        (this.resizeEdges.includes("l")
          ? '<div class="vue-modal-left"></div>'
          : "<!---->") +
        " " +
        (this.resizeEdges.includes("r")
          ? '<div class="vue-modal-right"></div>'
          : "<!---->") +
        " " +
        (this.resizeEdges.includes("tr")
          ? '<div class="vue-modal-topRight"></div>'
          : "<!---->") +
        " " +
        (this.resizeEdges.includes("tl")
          ? '<div class="vue-modal-topLeft"></div>'
          : "<!---->") +
        " " +
        (this.resizeEdges.includes("br")
          ? "<div" +
            _vm._ssrAttr("id", _vm.getID) +
            _vm._ssrClass(null, _vm.className) +
            "></div>"
          : "<!---->") +
        " " +
        (this.resizeEdges.includes("bl")
          ? '<div class="vue-modal-bottomLeft"></div>'
          : "<!---->")
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }